import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CoroutineDispatcherizb7p9bijexj as CoroutineDispatcher } from './CoroutineDispatcher.mjs';
import {
  checkParallelism305j5epqg3ju0 as checkParallelism,
  namedOrThis1pi8a62t67wtr as namedOrThis,
} from './internal/LimitedDispatcher.mjs';
import { invokeOnCancellationb68niwbjdmgy as invokeOnCancellation } from './CancellableContinuation.mjs';
import { Delay9umexudtwyie as Delay } from './Delay.mjs';
import { ArrayDeque2dzc9uld4xi7n as ArrayDeque } from '../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayDeque.mjs';
import { removeFirstOrNull15yg2tczrh8a7 as removeFirstOrNull } from '../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Runnablezd7bpy5et5p0 as Runnable } from './Runnable.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KtMutableList1beimitadwkna as KtMutableList } from '../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { coerceIn302bduskdb54x as coerceIn } from '../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { convertToInty04h231mmjoh as convertToInt } from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { boxApply1qmzdb3dh90hg as boxApply } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { CancelHandler3ic7xysezxbm5 as CancelHandler } from './CancellableContinuationImpl.mjs';
import { DisposableHandle1uzxt8frdchxn as DisposableHandle } from './Job.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NodeDispatcherClass;
function NodeDispatcher() {
  if (NodeDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        NodeDispatcher_instance = null;
        super();
        NodeDispatcher_instance = this;
      }
      x1k() {
        process.nextTick(this.e1l_1.c1l_1);
      }
    }
    initMetadataForObject($, 'NodeDispatcher', VOID, VOID, VOID, [1]);
    NodeDispatcherClass = $;
  }
  return NodeDispatcherClass;
}
var NodeDispatcher_instance;
function NodeDispatcher_getInstance() {
  if (NodeDispatcher_instance === VOID)
    new (NodeDispatcher())();
  return NodeDispatcher_instance;
}
var ScheduledMessageQueueClass;
function ScheduledMessageQueue() {
  if (ScheduledMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(dispatcher) {
        super();
        this.b1l_1 = dispatcher;
        var tmp = this;
        tmp.c1l_1 = () => {
          this.i1l();
          return Unit_instance;
        };
      }
      j1l() {
        this.b1l_1.x1k();
      }
      k1l() {
        setTimeout(this.c1l_1, 0);
      }
      l1l(timeout) {
        setTimeout(this.c1l_1, timeout);
      }
    }
    initMetadataForClass($, 'ScheduledMessageQueue');
    ScheduledMessageQueueClass = $;
  }
  return ScheduledMessageQueueClass;
}
function w3cSetTimeout(handler, timeout) {
  return setTimeout(handler, timeout);
}
var WindowMessageQueueClass;
function WindowMessageQueue() {
  if (WindowMessageQueueClass === VOID) {
    class $ extends MessageQueue() {
      constructor(window_0) {
        super();
        this.x1l_1 = window_0;
        this.y1l_1 = 'dispatchCoroutine';
        this.x1l_1.addEventListener('message', (event) => {
          var tmp;
          if (event.source == this.x1l_1 && event.data == this.y1l_1) {
            event.stopPropagation();
            this.i1l();
            tmp = Unit_instance;
          }
          return Unit_instance;
        }, true);
      }
      j1l() {
        var tmp = Promise.resolve(Unit_instance);
        tmp.then((it) => {
          this.i1l();
          return Unit_instance;
        });
      }
      k1l() {
        this.x1l_1.postMessage(this.y1l_1, '*');
      }
    }
    initMetadataForClass($, 'WindowMessageQueue');
    WindowMessageQueueClass = $;
  }
  return WindowMessageQueueClass;
}
function w3cSetTimeout_0(window_0, handler, timeout) {
  return setTimeout_0(window_0, handler, timeout);
}
function w3cClearTimeout(window_0, handle) {
  return window_0.clearTimeout(handle);
}
function w3cClearTimeout_0(handle) {
  return clearTimeout(handle);
}
function setTimeout_0(window_0, handler, timeout) {
  return window_0.setTimeout(handler, timeout);
}
var SetTimeoutDispatcherClass;
function SetTimeoutDispatcher() {
  if (SetTimeoutDispatcherClass === VOID) {
    class $ extends SetTimeoutBasedDispatcher() {
      constructor() {
        SetTimeoutDispatcher_instance = null;
        super();
        SetTimeoutDispatcher_instance = this;
      }
      x1k() {
        this.e1l_1.l1l(0);
      }
    }
    initMetadataForObject($, 'SetTimeoutDispatcher', VOID, VOID, VOID, [1]);
    SetTimeoutDispatcherClass = $;
  }
  return SetTimeoutDispatcherClass;
}
var SetTimeoutDispatcher_instance;
function SetTimeoutDispatcher_getInstance() {
  if (SetTimeoutDispatcher_instance === VOID)
    new (SetTimeoutDispatcher())();
  return SetTimeoutDispatcher_instance;
}
var SetTimeoutBasedDispatcherClass;
function SetTimeoutBasedDispatcher() {
  if (SetTimeoutBasedDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor() {
        super();
        this.e1l_1 = new (ScheduledMessageQueue())(this);
      }
      b13(parallelism, name) {
        checkParallelism(parallelism);
        return namedOrThis(this, name);
      }
      d13(context, block) {
        this.e1l_1.m1l(block);
      }
      s13(timeMillis, block, context) {
        var handle = w3cSetTimeout(() => {
          block.z11();
          return Unit_instance;
        }, delayToInt(timeMillis));
        return new (ClearTimeout())(handle);
      }
      r13(timeMillis, continuation) {
        var handle = w3cSetTimeout(() => {
          // Inline function 'kotlin.with' call
          continuation.nz(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (ClearTimeout())(handle));
      }
    }
    initMetadataForClass($, 'SetTimeoutBasedDispatcher', VOID, VOID, [Delay()], [1]);
    SetTimeoutBasedDispatcherClass = $;
  }
  return SetTimeoutBasedDispatcherClass;
}
var MessageQueueClass;
function MessageQueue() {
  if (MessageQueueClass === VOID) {
    class $ {
      constructor() {
        this.f1l_1 = ArrayDeque().qj();
        this.g1l_1 = 16;
        this.h1l_1 = false;
      }
      m1l(element) {
        this.n1l(element);
        if (!this.h1l_1) {
          this.h1l_1 = true;
          this.j1l();
        }
      }
      i1l() {
        try {
          // Inline function 'kotlin.repeat' call
          var times = this.g1l_1;
          var inductionVariable = 0;
          if (inductionVariable < times)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var tmp0_elvis_lhs = removeFirstOrNull(this);
              var tmp;
              if (tmp0_elvis_lhs == null) {
                return Unit_instance;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              var element = tmp;
              element.z11();
            }
             while (inductionVariable < times);
        }finally {
          if (this.n1()) {
            this.h1l_1 = false;
          } else {
            this.k1l();
          }
        }
      }
      n1l(element) {
        return this.f1l_1.i2(element);
      }
      i2(element) {
        return this.n1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      o1l(index, element) {
        this.f1l_1.b5(index, element);
      }
      b5(index, element) {
        return this.o1l(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      p1l(elements) {
        return this.f1l_1.u2(elements);
      }
      u2(elements) {
        return this.p1l(elements);
      }
      a5() {
        this.f1l_1.a5();
      }
      q1l(index, element) {
        return this.f1l_1.j3(index, element);
      }
      j3(index, element) {
        return this.q1l(index, (!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      c5(index) {
        return this.f1l_1.c5(index);
      }
      v2(index) {
        return this.f1l_1.v2(index);
      }
      b3(fromIndex, toIndex) {
        return this.f1l_1.b3(fromIndex, toIndex);
      }
      n1() {
        return this.f1l_1.n1();
      }
      r1l(element) {
        return this.f1l_1.t2(element);
      }
      t2(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return false;
        return this.r1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      p1() {
        return this.f1l_1.p1();
      }
      s1l(elements) {
        return this.f1l_1.q4(elements);
      }
      q4(elements) {
        return this.s1l(elements);
      }
      r2(index) {
        return this.f1l_1.r2(index);
      }
      t1l(element) {
        return this.f1l_1.r4(element);
      }
      r4(element) {
        if (!(!(element == null) ? isInterface(element, Runnable()) : false))
          return -1;
        return this.t1l((!(element == null) ? isInterface(element, Runnable()) : false) ? element : THROW_CCE());
      }
      q2() {
        return this.f1l_1.nj_1;
      }
    }
    initMetadataForClass($, 'MessageQueue', VOID, VOID, [KtMutableList()]);
    MessageQueueClass = $;
  }
  return MessageQueueClass;
}
var WindowClearTimeoutClass;
function WindowClearTimeout() {
  if (WindowClearTimeoutClass === VOID) {
    class $ extends ClearTimeout() {
      constructor($outer, handle, $box) {
        if ($box === VOID)
          $box = {};
        $box.s1m_1 = $outer;
        super(handle, $box);
      }
      xz() {
        w3cClearTimeout(this.s1m_1.u1m_1, this.w1m_1);
      }
    }
    initMetadataForClass($, 'WindowClearTimeout');
    WindowClearTimeoutClass = $;
  }
  return WindowClearTimeoutClass;
}
function Runnable$run$ref(p0) {
  var l = () => {
    p0.z11();
    return Unit_instance;
  };
  l.callableName = 'run';
  return l;
}
var WindowDispatcherClass;
function WindowDispatcher() {
  if (WindowDispatcherClass === VOID) {
    class $ extends CoroutineDispatcher() {
      constructor(window_0) {
        super();
        this.u1m_1 = window_0;
        this.v1m_1 = new (WindowMessageQueue())(this.u1m_1);
      }
      d13(context, block) {
        return this.v1m_1.m1l(block);
      }
      r13(timeMillis, continuation) {
        var handle = w3cSetTimeout_0(this.u1m_1, () => {
          // Inline function 'kotlin.with' call
          continuation.nz(this, Unit_instance);
          return Unit_instance;
        }, delayToInt(timeMillis));
        invokeOnCancellation(continuation, new (WindowClearTimeout())(this, handle));
      }
      s13(timeMillis, block, context) {
        var handle = w3cSetTimeout_0(this.u1m_1, Runnable$run$ref(block), delayToInt(timeMillis));
        return new (WindowClearTimeout())(this, handle);
      }
    }
    initMetadataForClass($, 'WindowDispatcher', VOID, VOID, [Delay()], [1]);
    WindowDispatcherClass = $;
  }
  return WindowDispatcherClass;
}
function delayToInt(timeMillis) {
  return convertToInt(coerceIn(timeMillis, 0n, 2147483647n));
}
var ClearTimeoutClass;
function ClearTimeout() {
  if (ClearTimeoutClass === VOID) {
    class $ {
      constructor(handle, $box) {
        boxApply(this, $box);
        this.w1m_1 = handle;
      }
      xz() {
        w3cClearTimeout_0(this.w1m_1);
      }
      wz(cause) {
        this.xz();
      }
      toString() {
        return 'ClearTimeout[' + this.w1m_1 + ']';
      }
    }
    initMetadataForClass($, 'ClearTimeout', VOID, VOID, [CancelHandler(), DisposableHandle()]);
    ClearTimeoutClass = $;
  }
  return ClearTimeoutClass;
}
//region block: exports
export {
  NodeDispatcher_getInstance as NodeDispatcher_getInstance2q3lgzi7kwduh,
  SetTimeoutDispatcher_getInstance as SetTimeoutDispatcher_getInstancemoakmytvf1nl,
  WindowDispatcher as WindowDispatcheram3q94j2gxvn,
};
//endregion

//# sourceMappingURL=JSDispatcher.mjs.map
